module.exports = __webpack_public_path__ + "static/media/tomato-rice.2685ab3e.jpg";